module.exports = __webpack_public_path__ + "img/fiba-emeklilik.04e44997.jpg";